export default "__VITE_ASSET__Gh_Mk$77__"